<template>
  <div v-loading="loading" class="member-detail">
    <el-card class="box-card" style="margin-bottom: 20px;">
      <div slot="header" class="card-header">
        <span>基本信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="goBack">返回</el-button>
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="会员ID">{{ memberDetail.memberId }}</el-descriptions-item>
        <el-descriptions-item label="用户名">{{ memberDetail.username }}</el-descriptions-item>
        <el-descriptions-item label="账户状态">
          <el-tag :type="getStatusTagType(memberDetail.status)" effect="dark">
            {{ memberDetail.statusText }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="手机号">{{ memberDetail.mobile }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ memberDetail.email }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ memberDetail.registerTime }}</el-descriptions-item>
        <el-descriptions-item label="最后登录">{{ memberDetail.lastLoginTime || '未登录' }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="box-card" style="margin-bottom: 20px;">
      <div slot="header">
        <span>账户信息</span>
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="账户余额">
          <span style="font-size: 18px; color: #f56c6c; font-weight: bold;">
            ${{ memberDetail.accountBalance }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="支付密码状态">
          <el-tag :type="memberDetail.paymentPasswordSet ? 'success' : 'warning'" effect="dark">
            {{ memberDetail.paymentPasswordSet ? '已设置' : '未设置' }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="box-card" style="margin-bottom: 20px;">
      <div slot="header">
        <span>订单统计</span>
      </div>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="总订单数">
          <span style="font-size: 20px; color: #409EFF; font-weight: bold;">
            {{ memberDetail.orderStatistics && memberDetail.orderStatistics.totalOrderCount || 0 }}
          </span>
          <span style="margin-left: 5px; color: #909399;">笔</span>
        </el-descriptions-item>
        <el-descriptions-item label="成功订单数">
          <span style="font-size: 20px; color: #67C23A; font-weight: bold;">
            {{ memberDetail.orderStatistics && memberDetail.orderStatistics.successOrderCount || 0 }}
          </span>
          <span style="margin-left: 5px; color: #909399;">笔</span>
        </el-descriptions-item>
        <el-descriptions-item label="退票订单数">
          <span style="font-size: 20px; color: #E6A23C; font-weight: bold;">
            {{ memberDetail.orderStatistics && memberDetail.orderStatistics.refundOrderCount || 0 }}
          </span>
          <span style="margin-left: 5px; color: #909399;">笔</span>
        </el-descriptions-item>
        <el-descriptions-item label="改签订单数">
          <span style="font-size: 20px; color: #909399; font-weight: bold;">
            {{ memberDetail.orderStatistics && memberDetail.orderStatistics.changeOrderCount || 0 }}
          </span>
          <span style="margin-left: 5px; color: #909399;">笔</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span>操作日志</span>
      </div>
      <el-table :data="memberDetail.operationLogs" border>
        <el-table-column type="index" label="序号" width="60px"></el-table-column>
        <el-table-column label="操作类型" prop="operationType" width="150px"></el-table-column>
        <el-table-column label="操作时间" prop="operationTime" width="160px"></el-table-column>
        <el-table-column label="操作人" prop="operator" width="120px"></el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { queryMemberDetail } from '@/api/member/memberApi'

export default {
  name: 'memberDetail',

  data () {
    return {
      loading: false,
      memberId: '',
      memberDetail: {
        orderStatistics: {},
        operationLogs: []
      }
    }
  },

  methods: {
    // 获取会员详情
    getMemberDetail () {
      this.loading = true
      queryMemberDetail(this.memberId).then(({ data, code }) => {
        if (code === this.$constant.SUCCESS) {
          this.memberDetail = data || {}
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    // 返回
    goBack () {
      this.$router.go(-1)
    },

    // 获取状态标签类型
    getStatusTagType (status) {
      const statusMap = {
        0: 'success',
        1: 'warning',
        2: 'danger'
      }
      return statusMap[status] || 'info'
    }
  },

  created () {
    this.memberId = this.$route.query.memberId || ''
    if (this.memberId) {
      this.getMemberDetail()
    } else {
      this.$message.error('会员ID不能为空')
      this.goBack()
    }
  }
}
</script>

<style lang="scss" scoped>
.member-detail {
  .box-card {
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
